/**
 * iOS Safari では window.open が非同期コールバック内でブロックされるため、
 * <a target="_blank"> 要素を DOM に挿入してクリックする方式を採用する。
 */
export const openInNewTab = (url: string): void => {
  const a = document.createElement('a')
  a.href = url
  a.target = '_blank'
  a.rel = 'noopener noreferrer'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}
